var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item){return _c('aside-updates-item',{key:item.id,attrs:{"status":item.status,"icon":item.icon,"ago":item.ago}},[_c('p',[_vm._v(_vm._s(item.text))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }